import {
  Input,
  Checkbox,
  Radio,
  Select,
  Datepicker,
  Autocomplete,
  Icon,
  Upload,
  Field,
  Tooltip,
  Dropdown,
  Progress,
  Message,
  Modal,
  Dialog,
  Steps,
  Button,
  Loading,
  Notification,
} from 'buefy';

export default {
  install(Vue) {
    Vue.use(Input);
    Vue.use(Checkbox);
    Vue.use(Radio);
    Vue.use(Select);
    Vue.use(Datepicker);
    Vue.use(Autocomplete);
    Vue.use(Icon);
    Vue.use(Upload);
    Vue.use(Field);
    Vue.use(Dropdown);
    Vue.use(Tooltip);
    Vue.use(Progress);
    Vue.use(Message);
    Vue.use(Modal);
    Vue.use(Dialog);
    Vue.use(Steps);
    Vue.use(Button);
    Vue.use(Loading);
    Vue.use(Notification);
  },
};
